export function RequestReturn() {

  this.lotNumber = '',
  this.transactionNumber = '',
  this.refundPartially = 0,
  this.returnType = '',
  this.comment = '',
  this.withApi = false,

  this.validation = {
    refundPartially: false,
    comment: false
  },

  this.validationTranslate = {
    refundPartially: '',
    comment: ''
  },

  this.validationTxt = {
    refundPartially: false,
    comment: false
  }
}

RequestReturn.prototype.setReturnType = function (val) {
  this.returnType = val
}

RequestReturn.prototype.getValidation = function () {
  return this.validation
}

RequestReturn.prototype.getValidationTranslate = function () {
  return this.validationTranslate
}

RequestReturn.prototype.getValidationTxt = function () {
  return this.validationTxt
}
